module.exports = __webpack_public_path__ + "static/media/ax.fdd00c43.svg";